<template>
  <div class="mii-table" :class="{'mii-table-1': style === 1, 'mii-table-2': style !== 1}">
    <table :class="{'table-style-1': table_style === 1, 'table-style-2': table_style !== 1, 'scroll-table': scroll_table_2}" v-if="tableData.length > 0">
      <thead v-if="!notShowThs">
        <tr>
          <th v-if="show_checkbox"><el-checkbox v-model="checkedAll"></el-checkbox></th>
          <!-- <th v-if="show_dian"></th> -->
          <th v-for="th in ths" @click="sortData(th.key, th.shortType)"><a href="javascript:;">{{th.label}}</a></th>
          <th v-if="realAction && table_actions && table_actions.length > 0"></th>
        </tr>
      </thead>
      <tbody :style="table_style_height">
        <tr v-for="(data, index) in (show_pagination ? (tableData || []).slice(start_index, start_index + this.row_num) : (tableData || []))" style="overflow: auto;max-height: 20rem;" @click="clickRow(data, index)" :style="getlineStyle ? getlineStyle(data) : {}" :class="{'chooseRow': data[lineSuo] === chooseRow}">
          <td v-if="show_checkbox"><el-checkbox v-model="data.checked"></el-checkbox></td>
          <!-- <td v-if="show_dian && data.STATUS"><div class="dian-div"> <div class="status-dian" :class="{'status-dian-1': data.STATUS === 'normal', 'status-dian-2': data.STATUS === 'plan', 'status-dian-3': data.STATUS === 'locking', 'status-dian-4': data.STATUS === 'done'}"></div></div></td> -->
          <td v-for="(th, index2) in ths">
            <a class="td-a" href="javascript:;" @click.stop="clickRowData(data, th.key, th.clickAction)" v-if="th.clickAction">
              {{th.showText ? th.showText(data[th.key]) : data[th.key]}}
            </a>
            <div v-html="th.showText ? th.showText(data[th.key]) : data[th.key]" v-else>
            </div>
          </td>
          <td v-if="realAction && table_actions && table_actions.length > 0" class="table-action">
            <a href="javascript:;" v-for="table_action in table_actions" v-if="!table_action.hideByData || table_action.hideByData(data)" @click.stop="clickTdBtn(data, table_action.key, index)">{{table_action.label}}</a>
          </td>
          <td class="action-td" v-if="!realAction &&table_actions && table_actions.length > 0">
            <div class="action-td-div">
              <a href="javascript:;" v-for="table_action in table_actions" v-if="!table_action.hideByData || table_action.hideByData(data)" @click.stop="clickTdBtn(data, table_action.key, index)">{{table_action.label}}</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination-table" v-if="show_pagination && tableData.length > 0">
      <el-pagination small layout="prev, pager, next" v-on:current-change="pageChange" :page-size="row_num" :total="(tableData || []).length">
      </el-pagination>
    </div>
    <div class="nodata-note" v-if="tableData.length === 0">
      无数据
    </div>
    <div style="display: none">{{chooseRowValue}}</div>
  </div>
</template>

<script>
import {
  clSortDatas,
  cmpDate,
  mapCp
} from '@/cllib'
export default {
  computed: {
    table_style_height: {
      get () {
        if (this.table_height && this.scroll_table) {
          return {
            height: this.table_height + 'rem'
          }
        } else {
          return {}
        }
      }
    },
    tableData: {
      get () {
        let vm = this
        let data = []
        this.datas.forEach(function (item) {
          data.push(item)
        })
        if (this.shortKey) {
          data = clSortDatas(data, function (a, b) {
            let short = false
            if (vm.shortType === 'time') {
              let aStr = a[vm.shortKey] && a[vm.shortKey] !== '无' ? ('2018-' + a[vm.shortKey]) : '2000-01-01'
              let bStr = b[vm.shortKey] && b[vm.shortKey] !== '无' ? ('2018-' + b[vm.shortKey]) : '2000-01-01'
              short = vm.shortOrderMax ? (cmpDate(aStr)).getTime() > (cmpDate(bStr)).getTime() : (cmpDate(aStr)).getTime() < (cmpDate(bStr)).getTime()
            } else if (vm.shortType === 'date_time') {
              let aStr = a[vm.shortKey] && a[vm.shortKey] !== '无' ? (a[vm.shortKey]) : '2000-01-01'
              let bStr = b[vm.shortKey] && b[vm.shortKey] !== '无' ? (b[vm.shortKey]) : '2000-01-01'
              short = vm.shortOrderMax ? (cmpDate(aStr)).getTime() > (cmpDate(bStr)).getTime() : (cmpDate(aStr)).getTime() < (cmpDate(bStr)).getTime()
            } else if (vm.shortType === 'text') {
              short = vm.shortOrderMax ? a[vm.shortKey] > b[vm.shortKey] : a[vm.shortKey] < b[vm.shortKey]
            } else {
              short = vm.shortOrderMax ? Number(a[vm.shortKey]) > Number(b[vm.shortKey]) : Number(a[vm.shortKey]) < Number(b[vm.shortKey])
            }
            return short
          })
        }
        return data
      }
    }
  },
  data () {
    return {
      chooseRow: -1,
      checkedAll: false,
      scroll_table_2: false,
      style: 0,
      page: 1,
      start_index: 0,
      shortKey: null,
      shortOrderMax: true,
      shortType: null
    }
  },
  watch: {
    chooseRowValue (value) {
      if (value.includes('car_id')) {
        let newData = null
        let carId = value.split('car_id-')[1]
        this.tableData.forEach((item) => {
          if (carId === item[this.lineSuo]) {
            newData = item
          }
        })
        if (newData) {
          this.chooseRow = carId
          this.$emit(this.chooseAction['action'], this.chooseAction.key ? {data: newData, key: this.chooseAction.key} : newData)
        }
      } else if (value.includes('top')) {
        // this.chooseRow = value
        this.nextData('top')
      } else {
        this.nextData('btm')
      }
    },
    checkedAll (value) {
      if (value) {
        this.datas.forEach((item) => {
          item.checked = true
        })
      } else {
        this.datas.forEach((item) => {
          item.checked = false
        })
      }
    }
  },
  methods: {
    nextData (key) {
      if (!this.chooseAction) {
        return
      }
      // 已有
      if (this.tableData.length > 0) {
        let newData = {}
        if (this.chooseRow) {
          let oldIndex = -1
          this.tableData.forEach((item, index) => {
            if (item[this.lineSuo] === this.chooseRow) {
              oldIndex = index
            }
          })
          if (oldIndex === -1) {
            newData = this.tableData[0]
          } else if (oldIndex === 0 && key === 'top') {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '已经是第一条数据了！'
            })
          } else if (oldIndex === this.tableData.length - 1 && key === 'btm') {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '已经是最后一条数据了！'
            })
          } else if (key === 'top') {
            newData = this.tableData[oldIndex - 1]
          } else if (key === 'btm') {
            newData = this.tableData[oldIndex + 1]
          }
        } else {
          newData = this.tableData[0]
        }
        if (newData[this.lineSuo]) {
          this.chooseRow = newData[this.lineSuo]
          this.$emit(this.chooseAction['action'], this.chooseAction.key ? {data: newData, key: this.chooseAction.key} : newData)
        }
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'info',
          title: '系统提示',
          message: '无数据!'
        })
      }
    },
    getlineStyle (data) {
      let styleMap = {}
      if (!this.lineQF) {
        return {}
      } else if (data['订单紧急程度'] === '紧急订单') {
        styleMap['background-color'] = '#f1a9a0'
      } else if (data['订单紧急程度'] === '可配送订单') {
        styleMap['background-color'] = '#fde3a7'
      } else if (data['订单紧急程度'] === '库存充足订单') {
        styleMap['background-color'] = '#90c695'
      }
      return styleMap
    },
    sortData (key, shortType) {
      this.shortType = shortType
      this.shortKey = key
      this.shortOrderMax = !this.shortOrderMax
    },
    clickRow (data, index) {
      if (this.lineSuo) {
        this.chooseRow = data[this.lineSuo] || -1
      }
      this.$emit('click_row', data)
    },
    clickRowData (data, thKey, actionKey) {
      this.$emit('click_row_data', {value: data[thKey], action: actionKey, rowdata: mapCp(data)})
    },
    pageChange (currentPage) {
      this.start_index = (currentPage - 1) * this.row_num
    },
    clickTdBtn (data, key, index) {
      if (this.lineSuo) {
        this.chooseRow = data[this.lineSuo] || -1
      }
      this.$emit('clickTdBtn', {data, key})
    }
  },
  props: ['datas', 'ths', 'table_style', 'row_num', 'show_pagination', 'scroll_table', 'table_height', 'table_actions', 'show_checkbox', 'realAction', 'lineQF', 'notShowThs', 'lineSuo', 'show_dian', 'chooseRowValue', 'chooseAction'],
  created () {
    this.style = (this.datas || []).length > 10 ? this.table_style : ((this.datas || []).length % 2 === 0 ? this.table_style : (3 - this.table_style))
    this.scroll_table_2 = this.scroll_table
  }
}
</script>

<style lang="less">
.mii-table{
  .icon-jiantou {
    font-weight: 600;
    padding: 0 0.2em;
  }
  .el-pagination button {
    background-color: rgba(0, 0, 0, 0);
  }
  .el-pager li {
    background-color: rgba(0, 0, 0, 0);
  }
  .el-pager li.active {
    background-color: #20a0ff;
  }
}
</style>

<style scoped lang="less">
@import '../style/base.less';
.dian-div {
  direction: flex;
  align-items: center;
  justify-content: center;
}
.status-dian {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 100%;
  transition: 1s;
}
.status-dian-1 {
  background: rgba(0,0,0,0);
}
.status-dian-2 {
  background: #E6A23C;
}
.status-dian-3 {
  background: #409EFF;
}
.status-dian-4 {
  background: #67C23A;
}
.action-td {
  position: relative;
  .action-td-div {
    position: absolute;
    display: none;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(1, 1, 1, 0.2);
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    padding:0 0.5rem;
    justify-content: center;
    align-items: center;
  }
  a {
    white-space:nowrap;
    font-size: 0.7rem;
    margin:0 0.2rem;
    line-height: 1.6;
    padding: 0 0.3rem;
    border-radius: 0.3rem;
    background-color: #081633;
    color: #00ccff;
  }
}
.nodata-note {
  text-align: center;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 0.5rem;
  color: #999;
}
.table-tool {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  i {
    font-size: 1.3rem;
    margin-left: 1rem;
    color: #fff;
  }
}
.scroll-table {
  tbody {
    display:block;
    height: 25rem;
    overflow-y:scroll;
  }
  thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
  }
}

.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.pagination-table {
  text-align: right;
  margin-right: 0.5em;
}
.mii-table {
  position: relative;
  display: flex;
  flex:1;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  padding-bottom: @content-border-radius-size;
  border-radius: @content-border-radius-size;
  input {
    width: 6em;
    line-height: 1;
    padding: 0;
    margin: 0;
    font-size: 1em;
  }
  table {
    border-spacing: 0;
    width: 100%;
    th {
      background-color: @bak-color-th;
      font-size: 1.13em;
      line-height: 2;
      color: @font-color-3;
      font-weight: 100;
      text-align: left;
      a {
        color: @font-color-3;
      }
    }
    .td-a {
      color: @font-color-3;
    }
    .td-a:hover {
      color: #00ccff;
    }
    td {
      // border-top: 0.1rem solid #f5f5f5;
      transition: 0.3s;
      text-align: left;
      font-size: 1em;
      line-height: 1.6;
      color: @font-color-3;
    }
    th:first-child {
      padding-left: 1rem;
    }
    td:first-child {
      padding-left: 1rem;
    }
    tbody {
      tr:hover {
        .action-td-div {
          display: flex;
        }
        background-color: rgba(11, 85, 145, 0.6) !important;
      }
      .chooseRow {
        background-color: rgba(11, 85, 145, 0.6) !important;
      }
    }
  }
  .table-action {
    display: flex;
    a {
      font-size: 0.7rem;
      margin:0 0.3rem;
      line-height: 1.6;
      padding: 0 0.5rem;
      border-radius: 0.2rem;
      background-color: #081633;
      color: #00ccff;
    }
  }
  .table-style-2 {
    tr:nth-child(odd){
      background: @bak-color-td-2;
    }
    tr:nth-child(even){
      background: @bak-color-td-1;
    }
  }
  .table-style-1 {
    tr:nth-child(odd){
      background: @bak-color-td-1;
    }
    tr:nth-child(even){
      background: @bak-color-td-2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// MiiBaseTable.vue?227291e3